module.exports = __webpack_public_path__ + "static_web/img/bot-logo.0e37f82f.png";